import React from 'react';
import './SocialLinks.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faYelp } from '@fortawesome/free-brands-svg-icons';

const SocialLinks = () => {
  return (
    <div className="social-links-wrapper flex row">
      <a
        href="https://www.instagram.com/thedoglodgesd/?hl=en"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="social-links-icon flex center"
      >
        <FontAwesomeIcon icon={faInstagram} aria-hidden="true" />
      </a>

      <a
        href="https://www.facebook.com/profile.php?id=61569081041152"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        className="social-links-icon flex center"
      >
        <FontAwesomeIcon icon={faFacebook} aria-hidden="true" />
      </a>

      <a
        href="https://www.yelp.com/biz/the-dog-lodge-daycare-and-boarding-san-diego?osq=The+Dog+Lodge+Daycare+and+Boarding&override_cta=Request+information"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Yelp"
        className="social-links-icon flex center"
      >
        <FontAwesomeIcon icon={faYelp} aria-hidden="true" />
      </a>
    </div>
  );
};

export default SocialLinks;
